import ProductLessons from './component'

export default ProductLessons
